(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("react-i18next"), require("react/jsx-runtime"));
	else if(typeof define === 'function' && define.amd)
		define("@genflowly/component-library", ["react", "react-dom", "react-i18next", "react/jsx-runtime"], factory);
	else if(typeof exports === 'object')
		exports["@genflowly/component-library"] = factory(require("react"), require("react-dom"), require("react-i18next"), require("react/jsx-runtime"));
	else
		root["@genflowly/component-library"] = factory(root["React"], root["ReactDOM"], root["ReactI18next"], root["ReactJSXRuntime"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__4012__, __WEBPACK_EXTERNAL_MODULE__6033__, __WEBPACK_EXTERNAL_MODULE__5805__, __WEBPACK_EXTERNAL_MODULE__4550__) => {
return 